/* eslint-disable import/extensions */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */

// Services Img Imports
import Sofware from "../assets/images/Services/Software.svg";
import OEM from "../assets/images/Services/OEM.svg";
import Professional from "../assets/images/Services/Professional.svg";
import Hardware from "../assets/images/Services/Hardware.svg";
import SofwareDark from "../assets/images/Services/Softwaredark.svg";
import OEMDark from "../assets/images/Services/OEMdark.svg";
import ProfessionalDark from "../assets/images/Services/Professionaldark.svg";
import HardwareDark from "../assets/images/Services/Hardwaredark.svg";

// Logos
import logo1 from "../assets/images/Logos/7.svg";
import Logo2 from "../assets/images/Logos/Fujitsu.svg";
import Logo3 from "../assets/images/Logos/Mc.svg";
import Logo4 from "../assets/images/Logos/Qantas.svg";
import Logo5 from "../assets/images/Logos/Schneider.svg";
import Logo6 from "../assets/images/Logos/Sydney.svg";
import Logo7 from "../assets/images/Logos/VictoriaState.svg";
import Logo8 from "../assets/images/Logos/Westpac.svg";
import Logo9 from "../assets/images/Logos/unsw.svg";
import Logo10 from "../assets/images/Logos/Pulford.svg";
import Logo11 from "../assets/images/Logos/nsw.svg";
import Logo12 from "../assets/images/Logos/JLL.svg";
import Logo13 from "../assets/images/Logos/Honeywell.svg";
import Logo14 from "../assets/images/Logos/Aldi 1.svg";
import Logo15 from "../assets/images/Logos/Costco.svg";
import Logo16 from "../assets/images/Logos/7d.svg";
import Logo17 from "../assets/images/Logos/Fujitsud.svg";
import Logo18 from "../assets/images/Logos/Macd.svg";
import Logo19 from "../assets/images/Logos/Qantasd.svg";
import Logo20 from "../assets/images/Logos/Schneiderd.svg";
import Logo21 from "../assets/images/Logos/SydneyD.svg";
import Logo22 from "../assets/images/Logos/VictoriaD.svg";
import Logo23 from "../assets/images/Logos/Westpacd.svg";
import Logo24 from "../assets/images/Logos/unswd.svg";
import Logo25 from "../assets/images/Logos/pulfordd.svg";
import Logo26 from "../assets/images/Logos/nswdark.svg";
import Logo27 from "../assets/images/Logos/JLLd.svg";
import Logo28 from "../assets/images/Logos/Honeywelld.svg";
import Logo29 from "../assets/images/Logos/aldidark.svg";
import Logo30 from "../assets/images/Logos/Costcod.svg";

// Slides
import slide1 from "../assets/Video/c1.webm";
import slide2 from "../assets/Video/c2.webm";
import slide3 from "../assets/Video/c3.webm";
import slide1dark from "../assets/Video/c1_dark.webm";
import slide2dark from "../assets/Video/c2_Dark.webm";
import slide3dark from "../assets/Video/c3_Dark.webm";

// AdvangeAbout
import Company from "../assets/images/AdvangesAbout/Company1.svg";
import CompanyDark from "../assets/images/AdvangesAbout/Company1Dark.svg";
import Growth from "../assets/images/AdvangesAbout/Global2.svg";
import Growthmobile from "../assets/images/AdvangesAbout/GlobalMobile.svg";
import GrowthDark from "../assets/images/AdvangesAbout/Global2Dark.svg";
import GrowthDarkMobile from "../assets/images/AdvangesAbout/GlobalmobileDark.svg";
import Excellence from "../assets/images/AdvangesAbout/Innovation3.svg";
import ExcellenceDark from "../assets/images/AdvangesAbout/Innovation3Dark.svg";
import Solutions from "../assets/images/AdvangesAbout/Future4.svg";
import SolutionsDark from "../assets/images/AdvangesAbout/Future4Dark.svg";
import IconsCom from "../assets/images/AdvangesAbout/IconsCom.png";
import IconsGro from "../assets/images/AdvangesAbout/ IconsGro.png";
import IconsExc from "../assets/images/AdvangesAbout/ IconsCom.png";
import IconsSol from "../assets/images/AdvangesAbout/GroupExc.png";

// Service Solutions
import Client from "../assets/images/ServiceSolutions/Client.svg";
import ClientDark from "../assets/images/ServiceSolutions/Clientdark.svg";
import Management from "../assets/images/ServiceSolutions/Establish.svg";
import ManagementDark from "../assets/images/ServiceSolutions/Establishdark.svg";
import Energy from "../assets/images/ServiceSolutions/Energy.svg";
import EnergyDark from "../assets/images/ServiceSolutions/Energydark.svg";

// Managers
import CEOT from "../assets/images/Team/TomFyfe.png";
import CTO from "../assets/images/Team/Aidan.png";
import COO from "../assets/images/Team/Matthew.png";
import IOT from "../assets/images/Team/Jonathan.png";
import CFO from "../assets/images/Team/Jonkane.png";

// solution Feature
import RubixSolu from "../assets/images/ImgFooter/RubixCompute.svg";
import Rubix16Solu from "../assets/images/ImgFooter/RubixiO16.svg";
import ExpansionSolu from "../assets/images/ImgFooter/RubixConnect.svg";

// AdvangeOEM Solutions
import Labelling from "../assets/images/AdvantageSolutionOEM/Labelling.svg";
import Labellingdark from "../assets/images/AdvantageSolutionOEM/Labellingdark.svg";
import Custom from "../assets/images/AdvantageSolutionOEM/Custom.svg";
import Customdark from "../assets/images/AdvantageSolutionOEM/Customdark.svg";
import Leveraging from "../assets/images/AdvantageSolutionOEM/Leveraging.svg";
import Leveragingdark from "../assets/images/AdvantageSolutionOEM/Leveragingdark.svg";
import Support from "../assets/images/AdvantageSolutionOEM/Support.svg";
import Supportdark from "../assets/images/AdvantageSolutionOEM/Supportdark.svg";

// OurStory
import IconsOur1 from "../assets/images/OurStory/Enviro1.svg";
import IconsOur2 from "../assets/images/OurStory/NubeiO2.svg";
import IconsOur3 from "../assets/images/OurStory/Software3svg.svg";
import IconsOur4 from "../assets/images/OurStory/Edge4.svg";
import IconsOur5 from "../assets/images/OurStory/RubixWires5.svg";
import IconsOur6 from "../assets/images/OurStory/NubeiOCloud6.svg";
import IconsOur7 from "../assets/images/OurStory/Hardwaresupport7.svg";
import IconsOur8 from "../assets/images/OurStory/RubixCompute8.svg";
import IconsOur9 from "../assets/images/OurStory/RubixWires9.svg";
import IconsOur10 from "../assets/images/OurStory/NubeiOMobile10.svg";
import IconsOur11 from "../assets/images/OurStory/Partnership11.svg";
import IconsOur12 from "../assets/images/OurStory/SoutheastAsia12.svg";
import IconsOur13 from "../assets/images/OurStory/ZoneControl13.svg";
import IconsOur14 from "../assets/images/OurStory/Enviro1Dark.svg";
import IconsOur15 from "../assets/images/OurStory/NubeiO2Dark.svg";
import IconsOur16 from "../assets/images/OurStory/Software3svgDark.svg";
import IconsOur17 from "../assets/images/OurStory/Edge4Dark.svg";
import IconsOur18 from "../assets/images/OurStory/RubixWires5Dark.svg";
import IconsOur19 from "../assets/images/OurStory/NubeiOCloud6Dark.svg";
import IconsOur20 from "../assets/images/OurStory/Hardwaresupport7Dark.svg";
import IconsOur21 from "../assets/images/OurStory/RubixCompute8Dark.svg";
import IconsOur22 from "../assets/images/OurStory/RubixWires9Dark.svg";
import IconsOur23 from "../assets/images/OurStory/NubeiOMobile10Dark.svg";
import IconsOur24 from "../assets/images/OurStory/Partnership11Dark.svg";
import IconsOur25 from "../assets/images/OurStory/SoutheastAsia12Dark.svg";
import IconsOur26 from "../assets/images/OurStory/ZoneControl13Dark.svg";

// Why partner
import Why1 from "../assets/images/WhoSupport/Dedicated.svg";
import Why1Dark from "../assets/images/WhoSupport/Dedicateddark.svg";
import Why2 from "../assets/images/WhoSupport/Technical.svg";
import Why2Dark from "../assets/images/WhoSupport/Technicaldark.svg";
import Why3 from "../assets/images/WhoSupport/Marketing.svg";
import Why3Dark from "../assets/images/WhoSupport/Marketingdark.svg";
import Why4 from "../assets/images/WhoSupport/Continuous.svg";
import Why4Dark from "../assets/images/WhoSupport/Continuousdark.svg";

// Testimonials
import AnyAir from "../assets/images/CaseStudy/Fujitsu_Blanco.png";
import fujitsu from "../assets/images/CaseStudy/Fujitsu.png";
import ESR from "../assets/images/CaseStudy/ESR.png";
import ESRDark from "../assets/images/CaseStudy/ESRDark.png";

export const Services = [
  {
    id: "Software",
    title: "Software",
    imageUrl: Sofware,
    imageUrlDark: SofwareDark,
    type: "Desktop, licence-free BMS programming software with real-time analytics and intuitive control.",
    animation: "left",
    link: "/software/",
  },
  {
    id: "Hardware",
    title: "Hardware",
    imageUrl: Hardware,
    imageUrlDark: HardwareDark,
    type: "Reliable, scalable devices designed for seamless integration and intelligent automation.",
    animation: "right",
    link: "/hardware/",
  },
  {
    id: "Professional",
    title: "Professional Services",
    imageUrl: Professional,
    imageUrlDark: ProfessionalDark,
    type: "Expert support, analytics, and insights to optimise your operational performance.",
    animation: "right",
    link: "/professional/",
  },
  {
    id: "OEM",
    title: "OEM ",
    imageUrl: OEM,
    imageUrlDark: OEMDark,
    type: "Fully customisable software and hardware solutions tailored specifically to your brands needs.",
    animation: "right",
    link: "/oem/",
  },
];

export const Logos = [
  {
    id: "Logo1",
    description: "Logo1",
    image: logo1,
    imageDark: Logo16,
    className: "h-1 w-1 ",
  },
  {
    id: "Logo2",
    description: "Logo2",
    image: Logo2,
    imageDark: Logo17,
    className: "h-1 w-1",
  },
  {
    id: "Logo3",
    description: "logo3",
    image: Logo3,
    imageDark: Logo18,
    className: "h-1 w-1",
  },
  {
    id: "Logo4",
    description: "logo4",
    image: Logo4,
    imageDark: Logo19,
    className: "h-1 w-1",
  },
  {
    id: "Logo5",
    description: "logo5",
    image: Logo5,
    imageDark: Logo20,
    className: "h-1 w-1",
  },
  {
    id: "Logo6",
    description: "Logo6",
    image: Logo6,
    imageDark: Logo21,
    className: "h-1 w-1",
  },
  {
    id: "Logo7",
    description: "logo7",
    image: Logo7,
    imageDark: Logo22,
    className: "h-1 w-1",
  },
  {
    id: "Logo8",
    description: "Logo8",
    image: Logo8,
    imageDark: Logo23,
    className: "h-1 w-1",
  },
  {
    id: "Logo9",
    description: "Logo9",
    image: Logo9,
    imageDark: Logo24,
    className: "h-1 w-1",
  },
  {
    id: "Logo10",
    description: "Logo10",
    image: Logo10,
    imageDark: Logo25,
    className: "h-1 w-1",
  },
  {
    id: "Logo11",
    description: "Logo11",
    image: Logo11,
    imageDark: Logo26,
    className: "h-1 w-1",
  },
  {
    id: "Logo12",
    description: "Logo12",
    image: Logo12,
    imageDark: Logo27,
    className: "h-1 w-1",
  },
  {
    id: "Logo13",
    description: "Logo13",
    image: Logo13,
    imageDark: Logo28,
    className: "h-1 w-1",
  },
  {
    id: "Logo14",
    description: "Logo14",
    image: Logo14,
    imageDark: Logo29,
    className: "h-1 w-1",
  },
  {
    id: "Logo15",
    description: "Logo15",
    image: Logo15,
    imageDark: Logo30,
    className: "h-1 w-1",
  },
];

export const Slides = [
  {
    id: "slide-1",
    image: slide1,
    imageDark: slide1dark,

    Subtitles: "The power to predict, adapt, and optimise",
    description:
      "Stay ahead with technology that anticipates changes in energy demand, system performance, and environmental conditions before they happen.",
  },
  {
    id: "slide-2",
    image: slide2,
    imageDark: slide2dark,
    Subtitles: "Total control of every connection",
    description:
      "Achieve seamless integration and visibility across devices, spaces, and systems, unified on one intuitive platform.",
  },
  {
    id: "slide-3",
    image: slide3,
    imageDark: slide3dark,
    Subtitles: "Insights that drive action",
    description:
      "Reveal hidden opportunities to improve efficiency, reduce costs, and enhance building performance.",
  },
];

export const Badges = [
  {
    title: "BACnet®",
    className: "size-1",
  },
  {
    title: "Modbus",
    className: "size-1",
  },
  {
    title: "Serial",
    className: "size-1",
  },
  {
    title: "LoRa®",
    className: "size-1",
  },
  {
    title: "LoRaWAN®",
    className: "size-1",
  },
  {
    title: "Logo1",
    className: "size-1",
  },
  {
    title: "Protocol Agnostic",
    className: "size-1",
  },
  {
    title: "Remote Access",
    className: "size-1",
  },
  {
    title: "Real-Time Insights",
    className: "size-1",
  },
  {
    title: "Multi-Site Control",
    className: "size-1",
  },
  {
    title: "AI + Analytics Ready",
    className: "size-1",
  },
];

export const AdvantageAbout = [
  [
    {
      image: Company,
      imageDark: CompanyDark,
      logo: IconsCom,
      title: "Why We Exist",
      description:
        "Building automation should be simple, smart, and accessible. We create tools that do more — with less complexity.",
    },
    {
      title: "Global Reach & Growth",
      description:
        "Founded in Australia, Nube iO bridges regions and time zones to deliver smart building solutions and local support worldwide.",
      logo: IconsGro,
      image: Growth,
      imageDark: GrowthDark,
      imagemobile: Growthmobile,
      imagemobileDark: GrowthDarkMobile,
    },
    {
      title: "Innovation & Impact",
      description:
        "Built by industry experts, our products simplify integration and maximise control.",
      logo: IconsExc,
      image: Excellence,
      imageDark: ExcellenceDark,
    },
    {
      title: "Future-Ready Technology",
      description:
        "With IoT-native design and protocol flexibility, our tech meets the demands of tomorrow — today. ",
      logo: IconsSol,
      image: Solutions,
      imageDark: SolutionsDark,
    },
  ],
];

export const OurStoryD = [
  [
    {
      id: 0,
      title: "Enviro Building Services Founded",
      description:
        "Foundation laid for future innovation in building services and facility optimisation.",
      date: "2009",
      icon: IconsOur1,
      iconDark: IconsOur14,
    },
    {
      id: 1,
      title: "Nube iO Begins Operations",
      description:
        "Launched with a mission to simplify building automation through advanced IoT and software solutions.",
      date: "2016",
      icon: IconsOur2,
      iconDark: IconsOur15,
    },
    {
      id: 2,
      title: "Global Software Support Established",
      date: "2017",
      description:
        "Development teams set up across time zones to provide continuous innovation and support.",
      icon: IconsOur3,
      iconDark: IconsOur16,
    },
    {
      id: 3,
      title: "First Hardware Release – Edge Gateway & Droplet Sensors",
      date: "2017",
      description:
        "Released initial IoT hardware devices enabling multi-site data collection and edge processing.",
      icon: IconsOur4,
      iconDark: IconsOur17,
    },
    {
      id: 4,
      title: "Rubix Wires Programming Software (v1.0)",
      date: "2018",
      description:
        "Introduced low-code configuration tool for seamless device programming and logic control.",
      icon: IconsOur5,
      iconDark: IconsOur18,
    },
    {
      id: 5,
      title: "Nube iO Cloud Platform Launched",
      date: "2018",
      description:
        "Released secure, scalable cloud infrastructure for remote monitoring and control.",
      icon: IconsOur6,
      iconDark: IconsOur19,
    },
    {
      id: 6,
      title: "Expanded Global Support – Dual Time Zones",
      date: "2020",
      description:
        "Scaled customer and technical support to operate effectively across Asia-Pacific and global regions.",
      icon: IconsOur7,
      iconDark: IconsOur20,
    },
    {
      id: 7,
      title: "Rubix Compute Gateway & iO16 Controller Released",
      date: "2020",
      description:
        "Launched key IoT edge devices, enabling integrated control and monitoring for BMS.",
      icon: IconsOur8,
      iconDark: IconsOur21,
    },
    {
      id: 8,
      title: "Rubix Wires Programming 2.0 Released",
      date: "2023",
      description:
        "Enhanced UI/UX and logic capabilities for system integrators and developers.",
      icon: IconsOur9,
      iconDark: IconsOur22,
    },
    {
      id: 9,
      title: "Nube iO Mobile App Launched",
      date: "2023",
      description:
        "Brought real-time BMS control and monitoring to mobile devices.",
      icon: IconsOur10,
      iconDark: IconsOur23,
    },
    {
      id: 10,
      title: "Partnership with Fujitsu General Australia",
      date: "2024",
      description:
        "Collaborated on HVAC control solutions as part of an OEM integration strategy.",
      icon: IconsOur11,
      iconDark: IconsOur24,
    },
    {
      id: 11,
      title: "Design Centre Vietnam",
      date: "2025",
      description:
        "Launched a regional design hub to support APAC growth, custom solutions, and partner integration.",
      icon: IconsOur12,
      iconDark: IconsOur25,
    },
    {
      id: 12,
      title: "Smart Home Solution Launched",
      date: "2025",
      description:
        "Introduced intelligent control technology for residential HVAC and energy automation.",
      icon: IconsOur13,
      iconDark: IconsOur26,
    },
  ],
];

export const ServiceSolutions = [
  {
    id: "Client",
    title: "Client Solutions",
    imageUrl: Client,
    imageUrlDark: ClientDark,
    type: "Tailored dashboards give complete visibility across building portfolio’s — all from the one platform. Nube iO seamlessly integrates with existing systems, delivering a unified view for monitoring, control, and scalable solution deployment.",
    animation: "left",
  },
  {
    id: "Energy",
    title: "Energy Analytics",
    imageUrl: Energy,
    imageUrlDark: EnergyDark,
    type: "Sustainability and green certifications like Green Star and NABERS are essential for client satisfaction. Nube iO helps optimise energy use, reducing consumption and ensuring your buildings run at optimal efficiency.",
    animation: "right",
  },
  {
    id: "Management",
    title: "Training & Support",
    imageUrl: Management,
    imageUrlDark: ManagementDark,
    type: "We provide comprehensive guidance for clients and contractors during the dashboard setup process. Ensuring all users are set-up for success, Nube iO empowers your team to deliver better business outcomes.",
    animation: "right",
  },
];

export const Managers = [
  {
    id: "person-1",
    name: "Tom Fyfe",
    role: "CEO",
    description:
      "Experienced leader driving growth and innovation across manufacturing and PropTech.",
    imageUrl: CEOT,
    linkedinUrl: "https://au.linkedin.com/in/tom-fyfe-8352aa51",
  },
  {
    id: "person-2",
    name: "Aidan Pickard",
    role: "CTO & Co-Founder",
    description:
      "HVAC & Automation Expert | 15+ Years Driving Smart Building Innovation.",
    imageUrl: CTO,
    linkedinUrl: "https://www.linkedin.com/in/aidan-pickard-b4689643/",
  },
  {
    id: "person-3",
    name: "Matthew Cady",
    role: "COO & Co-Founder",
    description:
      "Entrepreneurial finance expert managing operations, budgets, and key alliances.",
    imageUrl: COO,
    linkedinUrl: "https://www.linkedin.com/in/matt-cady-75596410b/",
  },
  {
    id: "person-4",
    name: "Jon Kane",
    role: "C.F.O",
    description:
      "Experienced finance leader in growth businesses across FMCG & manufacturing.",
    imageUrl: CFO,
    linkedinUrl: "https://www.linkedin.com/in/jon-kane-4564363/",
  },
  {
    id: "person-5",
    name: "Jonathan Hill",
    role: "General Manager",
    description:
      "Experienced manager leading operations, strategy, and successful project delivery.",
    imageUrl: IOT,
    linkedinUrl: "https://www.linkedin.com/in/jonathan-hill-6775b187/",
  },
];

export const Solutionsfeature = [
  {
    id: "feature-1",
    title: "Controllers",
    description:
      "Edge controller for real-time automation, local processing, and multi-protocol integration across your building systems.",
    image: RubixSolu,
    link: "/controllers/",
  },
  {
    id: "feature-2",
    title: "I/O Modules",
    description:
      "Compact I/O modules for scalable sensor and actuator control — perfect for HVAC, lighting, building services, and integration.",
    image: Rubix16Solu,
    link: "/io-modules/",
  },
  {
    id: "feature-3",
    title: "LoRa® Sensors",
    description:
      "Long-range, battery-powered LoRaWAN® sensors for accurate temperature, humidity, and indoor air quality monitoring.",
    image: IconsOur4,
    link: "/lorasensors/",
  },
  {
    id: "feature-4",
    title: "Expansion Modules",
    description:
      "Modular add-ons that extend controller functionality with more inputs, outputs, and smart communication features.",
    image: ExpansionSolu,
    link: "/expansionmodules/",
  },
];

export const AdvantageSolutions = [
  [
    {
      title: "White Labelling",
      description:
        "Custom-branded interfaces and hardware that let your product shine — with Nube iO behind the scenes.",
      imageUrl: Labelling,
      imageUrlDark: Labellingdark,
    },
    {
      title: "Scalable Commercial Models",
      description:
        "Flexible licencing and deployment strategies tailored to your business growth.",
      imageUrl: Custom,
      imageUrlDark: Customdark,
    },
  ],
  [
    {
      title: "Embedded Integration",
      description:
        "Seamlessly embed Rubix devices and software into your existing platforms and product ecosystem.",
      imageUrl: Leveraging,
      imageUrlDark: Leveragingdark,
    },
    {
      title: "Onboarding Enablement",
      description:
        "Partner toolkits, documentation, and training to get your team up and running — fast.",
      imageUrl: Support,
      imageUrlDark: Supportdark,
    },
  ],
];

export const WhyData = [
  [
    {
      id: "1",
      title: "Innovation",
      description:
        "Empower your offering with advanced technology, APIs, and integration tools designed for smart, scalable automation.",
      image: Why1,
      imageDark: Why1Dark,
    },
    {
      id: "2",
      title: "Sustainability",
      description:
        "Build efficient, future-ready environments with open systems that reduce energy use and support long-term goals.",
      image: Why2,
      imageDark: Why2Dark,
    },
    {
      id: "3",
      title: "Sales & Marketing",
      description:
        "Access tailored campaigns, co-branded assets, and strategic tools to grow visibility and drive commercial success.",
      image: Why3,
      imageDark: Why3Dark,
    },
    {
      id: "4",
      title: "Training & Support",
      description:
        "Equip your team with expert training, ongoing support, and the resources needed to deliver and scale confidently.",
      image: Why4,
      imageDark: Why4Dark,
    },
  ],
];

export const Testimonial = {
  text: "As part of our evolving controls strategy, Fujitsu General Australia conducted a comprehensive market review and identified Nube iO as the standout technology partner. Their robust, scalable technology stack offers a holistic solution for everything from small multi-site systems to large commercial projects. We’re proud to partner with an organisation whose innovative, collaborative and forward-thinking values align with ours. This partnership not only enhances our IoT capabilities but also signifies our commitment to integrating smart technology into our offerings— representing a major advancement in the relationship between technology and indoor comfort. By embracing these innovations, Fujitsu General Australia is positioned to meet market demands and lead the industry into the future.",
  name: "Kyle Rafter",
  role: "General Manager Product & Strategy, Fujitsu General",
  image1: AnyAir,
  image2: fujitsu,
};

export const Testimonial2 = {
  text: "ESR partnered with NUBE to find a simple metering solution for our industrial and logistics portfolio. The NUBE product provides ESR and our customers with a window into utilities performance and ongoing reporting requirements without the need for complex building management systems.",
  name: "Nick Morse",
  role: "Head of Property Operations , ESR",
  image1: ESR,
  imageDark: ESRDark,
};
